import { render } from "./BlogsSection.vue?vue&type=template&id=13d421df&scoped=true"
import script from "./BlogsSection.vue?vue&type=script&lang=js"
export * from "./BlogsSection.vue?vue&type=script&lang=js"

import "./BlogsSection.vue?vue&type=style&index=0&id=13d421df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d421df"]])

export default __exports__